//Options Resolver
(function(global) {
    class OptionsResolver {
        constructor(inputConfig) {
            this.config = typeof inputConfig === "undefined" ? {} : inputConfig;
        }

        getOption(key, defaultValue) {
            let value = defaultValue ? defaultValue : null;

            if (typeof this.config[key] != "undefined") {
                value = this.config[key];
            }

            return value;
        }
    }

    global.NS = global.NS || {};
    global.NS.Utils = global.NS.Utils || {};
    global.NS.Utils.OptionsResolver = OptionsResolver;
})(window);
